<template>
  <div class="reply-item flex">
    <!-- 左侧头像 -->
    <div class="left-avatar mr-2" style="">
      <UserAvatar :image-url="replyItem.UserAvatar" />
    </div>

    <div class="right-main flex-1 flex flex-col">
      <!-- 回复顶部信息 -->
      <div class="flex justify-between teld-color-gray mb-3">
        <div class="flex items-center">
          <span class="teld-color-gray font-semibold">{{ userNameDisplay }}</span>
          <SvgTriangle v-if="replyItem.RespondedUserID" width="8" height="8" class="mx-2"/>
          <span v-if="replyItem.RespondedUserID" class="teld-color-gray font-semibold">{{ replyItem.RespondedUserName }}</span>
        </div>
        <span :title="replyItem.ReplyTime" class="teld-color-gray">{{
          replyItem.ReplyTimeRelative
        }}</span>
      </div>

      <!-- 回复内容行 -->
      <div class="reply-content mb-3">
        <div
          v-if="!replyItem.IsDeleted"
          v-html="decodeURIComponent(replyItem.Content)"
          @click="onClickContent"
        ></div>
        <div v-else class="teld-color-gray">该条评论回复已删除</div>
      </div>

      <!-- 回复底部按钮行 -->
      <div class="flex justify-between">
        <!-- 相对时间 -->
        <!-- <span :title="replyItem.ReplyTime" class="teld-color-gray">{{
          replyItem.ReplyTimeRelative
        }}</span> -->
      </div>
      <div v-if="!replyItem.IsDeleted" class="reply-operations flex justify-end mb-3"
        :class="[disabled ? 'teld-color-lightgray' : 'teld-color-gray']"
      >
        <!-- 点赞 -->
        <div
          :tabindex="disabled ? -1 : 0"
          class="reply-like flex outline-on-focus rounded-sm leading-5 hover:text-theme-color"
          :class="[disabled ? 'cursor-not-allowed' : 'cursor-pointer']"
          @click="onClickLike"
        >
          <SvgHeartFilled v-show="replyItem.Liked" class="mr-1" />
          <SvgHeart v-show="!replyItem.Liked" class="mr-1" />
          <span class="">{{ replyItem.LikeCount || 0 }}</span>
        </div>
        <!-- 收藏 -->
        <div
          :tabindex="disabled ? -1 : 0"
          class="reply-star flex ml-2 outline-on-focus rounded-sm leading-5 hover:text-theme-color hidden"
          :class="[disabled ? 'cursor-not-allowed' : 'cursor-pointer']"
          @click="onClickFavorite"
        >
          <SvgStarFilled v-show="replyItem.IsFavorite" class="mr-1" />
          <SvgStar v-show="!replyItem.IsFavorite" class="mr-1" />
          <span class="">
            {{ replyItem.FavoriteCount || 0 }}
          </span>
        </div>
        <!-- 回复 -->
        <div
          :tabindex="disabled ? -1 : 0"
          class="reply-reply ml-2 outline-on-focus rounded-sm hover:text-theme-color"
          :class="[
            disabled ? 'cursor-not-allowed' : 'cursor-pointer',
            inputVisible ? 'teld-theme-color' : 'teld-color-gray'
          ]"
          @click="onClickReply"
        >回复</div>
        <!-- 删除 -->
        <div
          v-if="replyItem.CanCancel && !disabled"
          tabindex="0"
          class="reply-revoke ml-2 outline-on-focus rounded-sm hover:text-theme-color"
          @click="onClickRevoke"
        >删除</div>
      </div>

      <!-- 附件 -->
      <section
        v-if="replyItem.Attachments && replyItem.Attachments.length"
        class="attachments-section mb-2 border border-solid border-gray-100 rounded-sm"
      >
        <div
          v-for="attachment in replyItem.Attachments"
          :key="attachment.ID"
          class="attachment-file p-2 flex items-center"
          @click="handleDownloadFile(attachment)"
        >
          <!-- 文件类型图标 -->
          <FileTypeIcon :file-name="attachment.FileName" class="w-6 h-6 mr-2" />
          <!-- 文件名 -->
          <div
            class="flex-1 mr-2 van-multi-ellipsis--l2 text-xs overflow-hidden"
            :title="attachment.FileName"
          >
            {{ attachment.FileName }}
          </div>
        </div>
      </section>

      <!-- 评论的回复框 -->
      <draft-editor
        ref="draftEditorRef"
        :visible.sync="inputVisible"
        :placeholder="inputPlaceholder"
        class="h-0"
        @comment="onReplyToReply"
      />
    </div>
    
    <PersonnelInfoPopup
      :visible.sync="personnelInfoVisible"
      :user-id.sync="mentionedUserId"
    />
  </div>
</template>

<script>
// Components
import SvgHeart from "../../svg-icons/heart.vue";
import SvgHeartFilled from "../../svg-icons/heart-filled.vue";
import SvgStar from "../../svg-icons/star.vue";
import SvgStarFilled from "../../svg-icons/star-filled.vue";
import SvgTriangle from '../../svg-icons/triangle.vue';
import DraftEditor from '../draft-editor/index.vue';
import UserAvatar from '../../user-avatar.vue';
import FileTypeIcon from '../../file-type-icon/index.vue';
import PersonnelInfoPopup from '../personnel-info-popup/index.vue';

// Utils
import { relativeTime, saveAs } from "../../../core";
import dayjs from 'dayjs';

export default {
  name: "TmReplyItem",
  inject: ['loginUserInfo', 'pageUrl', 'notificationLink'],
  props: {
    /**
     * Reply数据条目
     */
    dataItem: {
      type: Object,
      default: () => {},
    },
    total: {
      type: Number,
      default: 0,
    },
    isCommentDeleted: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SvgHeart,
    SvgHeartFilled,
    SvgStar,
    SvgStarFilled,
    SvgTriangle,
    DraftEditor,
    // RevokePopover,
    UserAvatar,
    FileTypeIcon,
    PersonnelInfoPopup,
  },
  data() {

    return {
      // isLoading: true,
      inputVisible: false,
      replyItem: {},
      revokeConfirmVisible: false,
      //
      personnelInfoVisible: false,
      mentionedUserId: null,
    };
  },
  computed: {
    disabled() {
      return this.isCommentDeleted || this.replyItem.IsDeleted;
    },
    showReplyTo() {
      // TODO
      return true;
    },
    isAuthor() {
      const loginUser = this.loginUserInfo();
      return loginUser.userId === this.replyItem.UserID;
    },
    userNameDisplay() {
      return this.isAuthor ? '我' : this.replyItem.UserName;
    },
    inputPlaceholder() {
      return `回复 ${this.userNameDisplay}`;
    },
  },
  created() {
    const { ReplyTime } = this.dataItem;
    const timeRelative = relativeTime(ReplyTime);
    this.replyItem = {
      ...this.dataItem,
      ReplyTime: dayjs(ReplyTime).format('YYYY/MM/DD HH:mm:ss'),
      ReplyTimeRelative: timeRelative || "",
    };
  },
  methods: {
    async onClickLike() {
      if(this.disabled) return;
      const isLike = this.replyItem.Liked = !this.replyItem.Liked;
      const diff = this.replyItem.Liked ? 1 : -1;
      this.replyItem.LikeCount += diff;
      let succeeded = false;

      const payload = isLike
        ? { CommentID: this.replyItem.CommentID, TargetID: this.replyItem.ID }
        : { Id: this.replyItem.CommentID, TargetID: this.replyItem.ID};
      const serviceCode = isLike ? 'CMTS-Like' : 'CMTS-CancelLike';
      try {
        const { data } = await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl(serviceCode),
          data: isLike ? { comment: JSON.stringify(payload) } : { input: JSON.stringify(payload) },
        });

        if (data.state !== '1') {
          return;
        }

        succeeded = true;
        // this.$TM.Toast(isLike ? '已点赞' : '已取消点赞');
      } catch (error) {
        console.log(error);
      } finally {
        // 接口调用失败后，页面状态回滚
        if (!succeeded) {
          this.replyItem.Liked = !isLike;
          this.replyItem.LikeCount -= diff;
        }
      }
    },
    async onClickFavorite() {
      if(this.disabled) return;
      this.replyItem.IsFavorite = !this.replyItem.IsFavorite;
      const diff = this.replyItem.IsFavorite ? 1 : -1;
      this.replyItem.FavoriteCount += diff;
    },
    onClickReply() {
      if (this.disabled) return;
      this.inputVisible = true;
    },
    /** TODO 使用自定义的RevokeConfirm组件时用 */
    toggleRevokeConfirm() {
      this.revokeConfirmVisible = !this.revokeConfirmVisible;
    },
    async onClickRevoke() {
      if(this.disabled) return;

      // 确认
      try {
        await this.$TM.Dialog.confirm({
          title: '是否确定删除',
          showCancelButton: true,
          closeOnClickOverlay: true,
          confirmButtonColor: 'var(--theme-color)',
        });
      } catch (error) {
        // cancel
        return;
      }

      this.replyItem.IsDeleted = true;
      const onFail = () => {
        this.replyItem.IsDeleted = false;
        this.replyItem.CanCancel = false;
        this.$TM.Toast('删除失败');
      }

      try {
        const { data } = await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl('CMTS-CancelReply'), //+ `&id=${this.comment.ID}`,
          // method: 'GET',
          data: { id: this.replyItem.ID },
        });

        if (data.state !== '1') {
          onFail();
          return;
        }
        this.$TM.Toast('已删除');
        this.$emit('delete', this.replyItem);
      } catch (error) {
        console.log(error);
        onFail();
      }
    },
    async onReplyToReply(draftInfo) {
      const loginUser = this.loginUserInfo();
      const { content, fileList, onSucceed } = draftInfo;
      const newCommentReply = {
        // 接口必传字段：
        CommentID: this.replyItem.CommentID,
        Content: content,
        UserAvatar: loginUser.avatar,
        // RespondedUserID: this.replyItem.UserID,
        // RespondedUserName: this.replyItem.UserName,
        TargetID: this.replyItem.ID,
        Attachments: fileList.map(n => n.result),
        Url: this.notificationLink(),
        UrlParams: JSON.stringify({
          fpath: encodeURIComponent(this.pageUrl),
          showComment: true,
          commentId: this.replyItem.CommentID,
        }),
      }
      // 回复给
      if (loginUser.userId !== this.replyItem.UserID) {
        newCommentReply.RespondedUserID = this.replyItem.UserID;
        newCommentReply.RespondedUserName = this.replyItem.UserName;
      }

      try {
        const { data } = await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl('CMTS-SaveReply'),
          data: { reply: JSON.stringify(newCommentReply) },
        });
        console.log('SaveReply', data);
        if (data.state !== '1' || !data.data) {
          this.$TM.Toast('发送失败');
          return;
        }
        this.$TM.Toast('发送成功');

        // TODO 接口没有返回新数据对象，暂时用前端数据
        Object.assign(newCommentReply, {
          ID: 'comment-reply-m-' + parseInt(Math.random() * 1000), // TODO UI-mock
          ReplyTime: Date().toLocaleString(), // TODO UI-mock
          UserID: loginUser.userId, // TODO UI-mock
          UserName: loginUser.userName, // TODO UI-mock
          Liked: false, // TODO UI-mock
          LikeCount: 0, // TODO UI-mock
          IsFavorite: false, // TODO UI-mock
          FavoriteCount: 0, // TODO UI-mock
          IsDeleted: false, // TODO UI-mock
          CanCancel: true, // TODO UI-mock
        });

        // 调接口成功后清空输入框内容
        onSucceed();
        this.inputVisible = false;
        // 评论完将新添加评论展示出来
        this.$emit('reply', (data && data.data) || newCommentReply);
      } catch (error) {
        console.log(error);
        this.$TM.Toast('发送失败');
      }
    },
    onClickContent(e) {
      const el = e.target;
      // 如果点击了图片，则放大查看
      if (el.nodeName === 'IMG' && el.currentSrc) {
        this.$TM.ImagePreview({images:[el.currentSrc]});
      } else if(el.dataset.userId) {
        // 点击了提及人，则弹出人员信息
        this.mentionedUserId = el.dataset.userId;
        this.personnelInfoVisible = true;
      } else {
        // 点击了内容，则直接弹出回复框
        this.onClickReply();
      }
    },
    handleDownloadFile(attachment) {
      const { AttachmentUrl, FileName } = attachment;
      saveAs({
        url: AttachmentUrl,
        fileName: FileName,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>

